import { Link } from "react-router-dom";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";
import { InstallButton } from "@/components/InstallButton";

export const Brand = () => (
  <Link to="/" className="flex items-center gap-2.5" data-testid="brand-link">
    <div className="brand-mark" aria-hidden />
    <span className="font-heading text-3xl sm:text-4xl font-extrabold uppercase tracking-tight leading-none" data-testid="app-title">
      Diamond<span className="text-[var(--accent)]">Play</span>
    </span>
  </Link>
);

export const ThemeButton = () => {
  const { dark, toggle } = useTheme();
  return (
    <button data-testid="theme-toggle-button" className="icon-btn" onClick={toggle} aria-label="Toggle theme">
      {dark ? <Sun size={22} /> : <Moon size={22} />}
    </button>
  );
};

export const AppHeader = ({ children }) => (
  <header className="flex flex-wrap items-center gap-3 justify-between">
    <Brand />
    <div className="flex items-center gap-2 flex-wrap">
      {children}
      <InstallButton />
      <ThemeButton />
    </div>
  </header>
);

export const PageShell = ({ children }) => (
  <div className="app-shell">
    <div className="mx-auto max-w-7xl px-3 sm:px-6 py-3 sm:py-5 space-y-3 sm:space-y-4">{children}</div>
  </div>
);
